"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variantStyles = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _utils = require("../utils");

var _interfaces = require("./interfaces");

var variantStyles = function variantStyles(_ref, theme) {
  var colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      iconOnly = _ref.iconOnly,
      isDestructive = _ref.isDestructive,
      size = _ref.size,
      variant = _ref.variant;
  var selectors = theme.selectors;
  var isTertiary = variant === _interfaces.ButtonVariant.Tertiary;
  var hasDarkBackground = colorScheme === _interfaces.ButtonColorScheme.DarkBackground;

  var getColor = function getColor(colorKey) {
    return selectors.color(colorKey);
  };

  var backgroundColor = '';
  var color = '';
  var styles = {
    borderColor: 'transparent'
  };
  var stateStyles = {};

  if (iconOnly) {
    styles.minWidth = "".concat(_utils.A11Y_MIN_SIZE, "px");
  } else if (!isTertiary) {
    styles.minWidth = "".concat(size === _interfaces.ButtonSize.Small ? '96' : '128', "px");
  }

  if (disabled) {
    color = getColor('neutral70');
    backgroundColor = getColor('neutral10');
    styles.borderColor = color;
    stateStyles = {
      ':focus': {
        ':before': {
          borderColor: color
        }
      }
    };
  } else {
    var colorBase = isDestructive ? 'red' : 'primary';

    switch (variant) {
      case _interfaces.ButtonVariant.Primary:
        backgroundColor = getColor("".concat(colorBase).concat(hasDarkBackground ? '40' : '70'));
        color = getColor("neutral".concat(isDestructive && hasDarkBackground ? '100' : '0'));
        var primaryActiveBackgroundColor = getColor("".concat(colorBase).concat(hasDarkBackground ? '50' : '80'));
        stateStyles = (0, _utils.getStateStyles)({
          active: {
            backgroundColor: primaryActiveBackgroundColor
          },
          focus: {
            backgroundColor: primaryActiveBackgroundColor
          },
          hover: {
            backgroundColor: getColor("".concat(colorBase).concat(hasDarkBackground ? '30' : '60'))
          }
        }, primaryActiveBackgroundColor);
        break;

      case _interfaces.ButtonVariant.Tertiary:
        backgroundColor = 'transparent';
        color = getColor("".concat(colorBase).concat(hasDarkBackground ? '30' : '70'));
        var borderColor = getColor("".concat(colorBase).concat(hasDarkBackground ? '40' : '80'));
        stateStyles = (0, _utils.getStateStyles)({
          active: {
            borderColor: borderColor
          },
          focus: {
            borderColor: borderColor
          },
          hover: {
            borderColor: color
          }
        }, borderColor);
        break;

      case _interfaces.ButtonVariant.Secondary:
      default:
        backgroundColor = getColor("neutral".concat(hasDarkBackground ? '100' : '0'));
        color = getColor("".concat(colorBase).concat(hasDarkBackground ? '20' : '70'));
        stateStyles = (0, _utils.getStateStyles)({
          active: {
            backgroundColor: getColor("neutral".concat(hasDarkBackground ? isDestructive ? '90' : '80' : '10'))
          },
          focus: {
            backgroundColor: getColor("neutral".concat(hasDarkBackground ? '80' : '10'))
          },
          hover: {
            backgroundColor: getColor("neutral".concat(hasDarkBackground ? '90' : '05'))
          }
        }, color);
        styles.borderColor = color;
        break;
    }
  }

  return (0, _objectSpread2.default)({}, styles, stateStyles, {
    backgroundColor: backgroundColor,
    color: color
  });
};

exports.variantStyles = variantStyles;